import { BrightyLogo } from './BrightyLogo';
import { NodaAvatarLogo } from './NodaLogo';
import { WolfoAvatarLogo } from './WolfoLogo';

export function AvatarLogo({ size }: { size: number }) {
  if (__NODA__) {
    return <NodaAvatarLogo size={size} />;
  }

  if (__BRIGHTY__) {
    return <BrightyLogo size={size} />;
  }

  if (__WOLFO__) {
    return <WolfoAvatarLogo size={size} />;
  }

  return null;
}
